import {useContext} from "react";
import {IndicatorsContext} from "./indicators-context.ts";

const useProjectsIndicatorsContext = () => {
    const context = useContext(IndicatorsContext);
    if (!context) {
        throw new Error('useIndicateur must be used within an IndicateurProvider');
    }
    return context;
};

export default useProjectsIndicatorsContext;